import * as tslib_1 from "tslib";
import { lazyCreateUriFiles } from 'owa-attachment-common';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
import { infoBarAddHandler, infoBarRemoveHandler, } from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
export default function addFile(viewState, attachmentName, uri, isInline) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    lazyCreateUriFiles.import().then(function (createUriFiles) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var hasProcessed, handler, attachmentErrorHandler, onFinish, file, composePlugins, inlineImagePlugin, isPlainText, processInlineImageBeforeUpload;
                        return tslib_1.__generator(this, function (_a) {
                            hasProcessed = false;
                            handler = infoBarAddHandler(viewState);
                            attachmentErrorHandler = function (messageId, infoBarMessageViewStateCreator) {
                                handler(messageId, infoBarMessageViewStateCreator);
                                if (!hasProcessed) {
                                    hasProcessed = true;
                                    reject({ errorType: 'UploadError', id: messageId });
                                }
                            };
                            onFinish = function (attachmentId) {
                                if (!hasProcessed) {
                                    hasProcessed = true;
                                    resolve(attachmentId.Id);
                                }
                            };
                            try {
                                file = createUriFiles([{ name: attachmentName, url: uri }]);
                                composePlugins = findComposePlugins(viewState);
                                inlineImagePlugin = composePlugins.inlineImagePlugin;
                                isPlainText = viewState.bodyType != 'HTML';
                                processInlineImageBeforeUpload = isPlainText
                                    ? null
                                    : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);
                                createAttachments(file, isInline, viewState, false /* shouldShare */, true /* isHiddenInline */, processInlineImageBeforeUpload, attachmentErrorHandler, infoBarRemoveHandler(viewState), onFinish);
                            }
                            catch (err) {
                                reject({ errorType: 'UploadError' });
                            }
                            return [2 /*return*/];
                        });
                    }); });
                })];
        });
    });
}
//# sourceMappingURL=addFile.js.map